import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../core/abstraction/auth.service';
import { Utils } from 'src/app/pages/core/utils/Utils';
import { environment } from 'src/environments/environment';
import { AuthUtilsService } from '../../utils/auth-utils.service';
import { GoogleAnalyticsService } from 'src/app/utils/google-analytics.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent implements OnInit {
  code: string;
  loading: boolean;
  message = 'Confirmando email';
  errorMsg = undefined;
  error = false;
  actualYear: number = new Date().getFullYear();
  iosApp: string = environment.iosApp;
  constructor(
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    public router: Router,
    public utils: AuthUtilsService,
    private dialog: MatDialog,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((data) => {
      this.code = data.code;
      if (this.code) {
        this.loading = true;
        this.authService.confirmMail(this.code).subscribe(
          () => {
            this.googleAnalyticsService.emitEvent(
              'signup-email-confirm',
              'first-use',
              'email-confirmed',
            );
            this.loading = false;
            this.message = 'Email confirmado';
            if (this.authService.loggedUser) {
              this.authService.loggedUser.flags.mailConfirmed = true;
            }

            if (Utils.isIOSDevice()) {
              window.location.href = `${this.iosApp}://mailConfirmed`;
            }
            if (Utils.isAndroidDevice()) {
              window.location.href = `tiendacrypto://mailconfirmed?code=${encodeURIComponent(
                this.code,
              )}`;
            }

            setTimeout(() => {
              this.router.navigate(['auth', 'redirect']);
            }, 200);
          },
          (err) => {
            this.loading = false;
            this.error = true;
            this.errorMsg = 'Hubo un error ¿Iniciaste sesión en este dispositivo?';
            setTimeout(() => this.router.navigate(['/']), 2000);
          },
        );
      }
    });
  }
}
